import axios from "axios";
import store from "../store/index.js";
import router from "../router/index.js";
// 引入 Vant 的 Toast
import { Toast } from "vant";

// 创建axios实例
const service = axios.create({
  // baseURL: "http://192.168.110.227:8886", // 从环境变量读取基础URL
  // baseURL: "http://192.168.110.68:8886", // 从环境变量读取基础URL
  baseURL: "https://www.sxtnkl.com/cattle-pc", // 从环境变量读取基础URL
  timeout: 10000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求前做些什么（如添加token）
    const token = localStorage.getItem("token");
    // console.log('当前 token:', token);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    Toast.fail("请求出错，请稍后重试");
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // console.log(response,'123123adasd');
    console.log(response.data.code);

    if (response.data.code === 401) {
      // 处理未授权情况，例如跳转到登录页面或刷新token
      // store.dispatch('user/logout') // 调用退出登录的action
      router.push("/"); // 跳转到登录页面
      console.error("未授权，请重新登录");
      return Promise.reject({ code: 401, msg: response.data.msg });
    }
    if (response.data.code === 500) {
      console.error(response.data.msg);
      return Promise.reject({ code: 500, msg: response.data.msg });
    }
    // 对响应数据做处理
    return response.data;
  },
  (error) => {
    let { message } = error;
    if (message === "Network Error") {
      message = "服务连接异常";
      console.error(message);
    } else if (axios.isTimeout(error)) {
      message = "系统接口请求超时，请检查网络连接或稍后重试";
      console.error(message);
    } else if (message.includes("Request failed with status code")) {
      const statusCode = message.substr(message.length - 3);
      message = `系统接口${statusCode}异常`;
      console.error(message);
    }
    console.error(message);

    // 返回一个包含错误信息的对象，而不是直接抛出错误
    return Promise.reject({ code: error.response?.status || -1, msg: message });
  }
);

export default service;
